<template>
  <div class="landing" v-if="pageVisible">
    <MessageBar :message="currentMessage" :isError="isErrorMessage"></MessageBar>

    <SidebarSite :forceVisible="forceSidebarVisible"></SidebarSite>

    <Header></Header>

    <div class="landing-content" v-on:click="closeSidebar">
      <div class="header-image">
        <div class="header-text">
          PowerSlide Makes Digital Signage Easy
        </div>
        <button class="button header-button" v-on:click="getStarted">
          Get Started Today!
        </button>
      </div>

      <div class="content-item">
        <h1>Digital Signage Made Easy</h1>
        <p class="subtext">
          PowerSlide digital signage software is a modern, low cost, cloud-based digital signage app.
        </p>
      </div>

      <div class="content-item">
        <div class="column-item">
          <img class="icon" src="../assets/images/low-cost-icon.svg" />
          <h3>Low Cost</h3>
          <hr>
          PowerSlide provides low cost, convenient access to a dynamic digital signage platform.
        </div>
        <div class="column-item">
          <img class="icon" src="../assets/images/customize-icon.svg" />
          <h3>Easy To Use</h3>
          <hr>
          PowerSlide is simple to use.  No technical skill, IT involvement, or software installation is required.
        </div>
        <div class="column-item">
          <img class="icon" src="../assets/images/customer-experience.svg" />
          <h3>High Value</h3>
          <hr>
          Increase customer engagement and retention with high impact digital signage, content rich Customization Dashboard, on-screen promotions, dedicated product support, and more.
        </div>
        <div class="column-item">
          <img class="icon" src="../assets/images/sales-growth.svg" />
          <h3>Increase Sales</h3>
          <hr>
          Enhance your brand, product exposure, and extend your digital marketing reach anywhere.
        </div>
        <div class="column-item">
          <img class="icon" src="../assets/images/television-icon.svg" />
          <h3>Compatible with all Devices</h3>
          <hr>
          PowerSlide works on all TVs and digital display devices. The good news, no need to upgrade your existing TVs.
        </div>
      </div>

      <div class="content-row">
        <h1>Sign up for the PowerSlide Newsletter</h1>
        <p class="subtext">
          Enter your email to receive updates about PowerSlide
        </p>

        <div class="form-container">
          <div class="message" v-bind:class="{error: validation.hasError('email')}">{{ validation.firstError('email') }}</div>
          <input type="email" v-bind:class="{errorInput: validation.hasError('email')}" v-model="email" placeholder="email@example.com"/>

          <button class="button" v-on:click="submit">
            Submit
          </button>
        </div>
      </div>

      <div class="content-item">
        <div class="tv">
          <Slider class="tv-slider" :slideshow="slideshowMini" :mini="true"></Slider>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import '../styles/base.css'
import Footer from './Footer.vue'
import Header from './Header.vue'
import MessageBar from './MessageBar.vue'
import SidebarSite from './SidebarSite.vue'
import SimpleVueValidation from 'simple-vue-validator'
import Slider from './Slider.vue'

const Validator = SimpleVueValidation.Validator

export default {
  name: 'Landing',

  components: {
    Footer,
    Header,
    MessageBar,
    SidebarSite,
    Slider
  },

  data () {
    return {
      currentMessage: '',
      email: '',
      forceSidebarVisible: false,
      isErrorMessage: false,
      pageVisible: false,
      slideshowMini: {
        controls: false,
        delay: 5,
        name: 'Demo Slideshow',
        pagination: false,
        slide_selector: false,
        slides: [
          {
            caption: '',
            image: 'https://powerslide-images.s3.amazonaws.com/demo1.jpg',
            position: 0,
            transition: 'fall',
            id: '',
            status: 'development',
            user_id: '',
            _id: ''
          },
          {
            caption: '',
            image: 'https://powerslide-images.s3.amazonaws.com/demo2.jpg',
            position: 1,
            transition: 'blocks2',
            id: '',
            status: 'development',
            user_id: '',
            _id: ''
          },
          {
            caption: '',
            image: 'https://powerslide-images.s3.amazonaws.com/demo3.jpg',
            position: 2,
            transition: 'blocks1',
            id: '',
            status: 'development',
            user_id: '',
            _id: ''
          }
        ]
      }
    }
  },

  methods: {
    closeSidebar: function () {
      if (this.forceSidebarVisible) {
        this.forceSidebarVisible = false
      }
    },

    getLiveDemo: function () {
      let data = {
        email: this.email
      }

      this.axios.post('/api/demo', data)
        .then((response) => {
          this.$gtag.event('demo-requested', { method: 'Google' })
          this.setCurrentMessage('Thanks, we will keep you posted with PowerSlide news!', false)
          this.email = ''
          this.validation.reset()
        }).catch((err) => {
          if (err.response.data.error) {
            this.setCurrentMessage(err.response.data.error, true)
          } else {
            this.setCurrentMessage(err, true)
          }
        })
    },

    getStarted: function () {
      this.$router.push('/get-started')
    },

    setCurrentMessage: function (message, isError) {
      this.currentMessage = message
      this.isErrorMessage = isError
    },

    submit: function () {
      this.$validate()
        .then((success) => {
          if (success) {
            this.getLiveDemo()
          }
        })
    }
  },

  mounted () {
    // Cordova app loaded
    document.addEventListener('deviceready', () => {
      PS.platform = window.device.platform
      if (PS.platform === 'amazon-fireos') {
        this.$router.push('/login')
      }

      // eslint-disable-next-line
      cordova.getAppVersion.getVersionNumber(function (version) {
        PS.appVersion = version
      })

      navigator.splashscreen.hide()
    })

    // Normal webpack site loaded
    if (window.device === undefined) {
      this.pageVisible = true
    }
  },

  validators: {
    email: function (value) {
      return Validator.value(value).required().email()
    }
  }
}
</script>

<style scoped>
  .button {
    background: var(--secondary);
    font-size: 1.2em;
    padding: .75em 1em;
  }

  .button:hover {
    background: var(--secondary-dark);
  }

  .column-item {
    border: 1px solid #ccc;
    border-radius: 1em;
    display: inline-block;
    height: 370px;
    padding: 1.5em 1em;
    margin: 1em;
    vertical-align: top;
    width: 300px;
  }

  .content-item {
    margin-top: 3em;
    text-align: center;
    width: 100%;
  }

  .content-row {
    background-color: #eaeaea;
    margin: 3em 0 4em 0;
    padding: 2em;
    text-align: center;
  }

  .form-container {
    margin-top: .25em;
  }

  .header-button {
    margin: 2em auto 0 auto;
    padding: 1em;
    width: 250px;
  }

  .header-image {
    background-image: url(https://powerslide-images.s3.amazonaws.com/powerslide_slide1.jpg);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 620px;
    padding-top: 5em;
    text-align: center;
    width: 100%;
  }

  .header-text {
    color: white;
    font-size: 4em;
    font-weight: 900;
    margin: 0 auto;
    max-width: 750px;
  }

  h1 {
    margin: 0;
  }

  hr {
    background: #ccc;
    border: none;
    height: 1px;
    margin: 1.5em 1em;
  }

  .icon {
    display: block;
    height: 100px;
    margin: 0 auto;
    width: 100px;
  }

  input[type=email] {
    border: 1px solid #ccc;
    display: inline-block;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 1.2em;
    margin-bottom: 1em;
    outline: none;
    padding: .7em;
    width: 300px;
  }

  .landing {
    background: var(--landing-bg);
    display: block;
    min-height: 100vh;
    margin: 0 auto;
    position: relative;
  }

  .landing-content {
    margin: 0 auto;
    width: 100%;
  }

  .message {
    height: 22px;
    margin-bottom: .5em;
  }

  /* .slider {
    margin-top: 70px;
  } */

  .subtext {
    font-size: 1.2em;
    margin: 0 auto;
    width: 90%;
  }

  .tv {
    border: 1em solid #252525;
    box-shadow: 0 8px 20px -6px black;
    height: 520px;
    margin: 0 auto 4em auto;
    width: 900px;
  }

  .tv-slider {
    margin-top: 0 !important;
  }

  @media only screen and (max-width: 750px) {
    .header-text {
      font-size: 3em;
    }
  }

  @media only screen and (max-width: 920px) {
    .tv {
      height: 243px !important;
      width: 407px !important;
    }
  }
</style>
